export default "__VITE_ASSET__bce5180c__"